import backgroundImage from '@images/header-images/case-studies-header.svg';

export const caseStudiesHeaderProps = {
  title: 'Case studies',
  backgroundImage: backgroundImage,
  backgroundImageAlt: 'Case studies',
};
